<ng-container *ngIf="!isEditing">
  <EXP__glxy-wrap>
    <mat-form-field>
      <mat-label>
        {{ 'AUTOMATIONS.TABLE.FILTERS.SEARCH' | translate }}
      </mat-label>
      <input matInput [formControl]="searchControl" />
    </mat-form-field>
  </EXP__glxy-wrap>
  <glxy-checkbox [(ngModel)]="showDisabledItems">
    {{ 'AUTOMATIONS.TABLE.FILTERS.SHOW_DISABLED' | translate }}
  </glxy-checkbox>
  <ng-container *ngIf="availableTriggers$ | async as categories; else loadingCard">
    <automata-task-category-list
      [categories]="categories"
      (taskClicked)="triggerSelected($event)"
      [showDisabledItems]="showDisabledItems"
      [useTriggerInvalidMessageInsteadOfActionInvalidMessage]="true"
    ></automata-task-category-list>
  </ng-container>
  <ng-container *ngIf="showInternalTriggers$ | async">
    <ng-container *ngIf="internalTriggers$ | async as categories; else loadingCard">
      <automata-task-category-list
        [categories]="categories"
        (taskClicked)="triggerSelected($event)"
      ></automata-task-category-list>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container
  *ngIf="
    ((availableTriggers$ | async)?.length === 0 && (showInternalTriggers$ | async) === false) ||
    ((showInternalTriggers$ | async) === true &&
      (internalTriggers$ | async)?.length === 0 &&
      (availableTriggers$ | async)?.length === 0)
  "
>
  <div class="no-results">{{ 'AUTOMATIONS.EDITOR.NO_RESULTS' | translate }}</div>
</ng-container>
<ng-container *ngIf="isEditing">
  <ng-container *ngIf="(savingEnabled$ | async) === true">
    <automata-task-error-disclaimer
      [stepId]="step?.id"
      [isTrigger]="step?.id === automation?.triggerStep?.id"
    ></automata-task-error-disclaimer>
    <button
      *ngIf="automation.runningState !== RUNNING"
      class="remove-trigger-button"
      mat-icon-button
      (click)="enterListOfTriggersView()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </ng-container>
</ng-container>
<ng-template automataDynamicComponent></ng-template>
<ng-template #loadingCard>
  <div class="loading-card stencil-shimmer"></div>
</ng-template>
